module.exports = __webpack_public_path__ + "img/card-rempro-speexplic-report.a44f62d5.svg";